import React from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SolutionsGrid from "@/components/SolutionsGrid";
import SolutionsCarousel from "@/components/SolutionsCarousel";
import MarketingWheel from "@/components/MarketingWheel";
import NumbersSection from "@/components/NumbersSection";
import AuthoritySection from "@/components/AuthoritySection";
import VideoSection from "@/components/VideoSection";
import LeadForm from "@/components/LeadForm";
import SchedulingSection from "@/components/SchedulingSection";
import Footer from "@/components/Footer";
import Watermark from "@/components/Watermark";
import Reveal from "@/components/Reveal";
import { WhatsappIcon } from "@/components/Navbar";
import { buildWhatsappLink } from "@/lib/brand";

export default function Landing() {
  return (
    <div className="relative bg-efory-ink min-h-screen overflow-x-hidden">
      <Watermark />
      <Navbar />
      <main className="relative">
        <Hero />
        <Reveal><SolutionsGrid /></Reveal>
        <Reveal><SolutionsCarousel /></Reveal>
        <Reveal><MarketingWheel /></Reveal>
        <Reveal><NumbersSection /></Reveal>
        <Reveal><AuthoritySection /></Reveal>
        <Reveal><VideoSection /></Reveal>
        <Reveal><LeadForm /></Reveal>
        <Reveal><SchedulingSection /></Reveal>
      </main>
      <Footer />

      {/* Floating WhatsApp */}
      <motion.a
        href={buildWhatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 200 }}
        className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl shadow-[#25D366]/40 hover:scale-110 transition-transform duration-300"
        aria-label="Falar no WhatsApp"
      >
        <WhatsappIcon className="h-7 w-7 text-white" />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      </motion.a>
    </div>
  );
}
